import { render, staticRenderFns } from "./CadastrarTecnicoServico.vue?vue&type=template&id=83f588de&scoped=true"
import script from "./CadastrarTecnicoServico.vue?vue&type=script&lang=js"
export * from "./CadastrarTecnicoServico.vue?vue&type=script&lang=js"
import style0 from "./CadastrarTecnicoServico.vue?vue&type=style&index=0&id=83f588de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f588de",
  null
  
)

export default component.exports